import React, { useEffect } from "react";
import { useTranslate } from "../Translate/Translate";

//import  './TableFooter.css';
import    './FooterTable.css'

const TableFooter = ({ range, setPage, page, slice }) => {
  const tableFooterLabel = useTranslate("TableFooter");
  const prevPageLabel = useTranslate("PrevPage");
  const nextPageLabel = useTranslate("NextPage");

  useEffect(() => {
    if (slice.length < 1 && page !== 1) {
      setPage(page - 1);
    }
    

  }, [slice, page, setPage]);
  return (
    <div className="tableFooter" role="navigation" aria-label={tableFooterLabel} >
      {page>1 && <button className="prevButton actionButton" aria-label={prevPageLabel} onClick={() => setPage(page-1)}></button>}
      {
        range.map((el, index) => (
        <>
        { 
           index > page-4 && index < page+2 &&
        <button
          key={index}
          className={`button ${
            page === el ? "activeButton" : "inactiveButton"
          }`}
          onClick={() => setPage(el)}
        >
          {el}
        </button>
      }
    </>
      ))}
    {page<range.length && <button className="nextButton actionButton" aria-label={nextPageLabel} onClick={() => setPage(page+1)}></button>}
     
    </div>
  );
};

export default TableFooter;